import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=0e1ee795&scoped=true&"
import script from "./Root.vue?vue&type=script&setup=true&lang=js&"
export * from "./Root.vue?vue&type=script&setup=true&lang=js&"
import style0 from "@/assets/styles/cruise-styles-main.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./Root.vue?vue&type=style&index=1&id=0e1ee795&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1ee795",
  null
  
)

export default component.exports